import { render } from "./RippIsteinSeilzugflaechen.vue?vue&type=template&id=5a52af6d&scoped=true&ts=true"
import script from "./RippIsteinSeilzugflaechen.vue?vue&type=script&lang=ts"
export * from "./RippIsteinSeilzugflaechen.vue?vue&type=script&lang=ts"

import "./RippIsteinSeilzugflaechen.vue?vue&type=style&index=0&id=5a52af6d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a52af6d"]])

export default __exports__